var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._b({},'div',_vm.attr,false),[_c(_vm.tag,_vm._b({tag:"component"},'component',_vm.attr,false),[_c('div',{domProps:{"innerHTML":_vm._s(_vm.$dompurify(_vm.htmlContent))}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }